import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Cdr } from 'src/app/models/centrex/cdr';
import { OrganizationsService } from '../organizations.service';
import { ServiceBase } from '../service-base';

@Injectable({
    providedIn: 'root',
})
export class CdrService extends ServiceBase {
    constructor(private http: HttpClient, private organizationsServices: OrganizationsService) {
        super();
    }

    getCdrs(fromDate: Date, toDate: Date): Observable<Cdr[]> {
        const httpOptions = {
            headers: new HttpHeaders().set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
        };

        let url = `${this.baseUrl}/api/cdrs?`;
        if (fromDate) url += '&fromDate=' + fromDate.toISOString();
        if (toDate) url += '&toDate=' + toDate.toISOString();

        return this.http.get<Cdr[]>(url, httpOptions);
    }
}
